import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';

export interface TeamItem {
  id?: number;
  lang: 'geo' | 'eng' | 'rus';
  page?: number;

  name: string;
  work_position: string;

  image?: string;
  content?: string;

  linkedin?: string;
  facebook?: string;
  gmail?: string;

  candidat?: string;
  archevnebi?: string;
  birthday?: string;
  phone?: string;

  visible: number;
}

@Injectable({ providedIn: 'root' })
export class TeamService {
  private api = environment.apiUrl;

  constructor(private http: HttpClient) {}

  list(params: { lang: string; search?: string; visible?: 'all' | 0 | 1 }) {
    return this.http.get<any>(`${this.api}admin/teams`, { params: params as any });
  }

  getOne(id: number, lang: string) {
    return this.http.get<any>(`${this.api}admin/teams/${id}`, { params: { lang } });
  }

  create(payload: Partial<TeamItem>) {
    return this.http.post<any>(`${this.api}admin/teams`, payload);
  }

  update(id: number, payload: Partial<TeamItem>, lang: string) {
    return this.http.post<any>(`${this.api}admin/teams/${id}`, { ...payload, lang });
  }

  toggleVisible(id: number, lang: string) {
    return this.http.post<any>(`${this.api}admin/teams/${id}/toggle-visible`, { lang });
  }

  delete(id: number, lang: string) {
    return this.http.post<any>(`${this.api}admin/teams/${id}/delete`, { lang });
  }

  sort(lang: string, ids: number[]) {
    return this.http.post<any>(`${this.api}admin/teams/sort`, { lang, ids });
  }
}